import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

/**
 * Role-gated guard.
 *
 *   <ProtectedRoute roles={["super_admin"]}> ...  — admin JWT required
 *   <ProtectedRoute student>              ...    — student session required
 */
export default function ProtectedRoute({ roles, student: studentOnly, children }) {
  const { admin, student } = useAuth();
  const location = useLocation();

  if (studentOnly) {
    if (!student) {
      return <Navigate to="/student/login" state={{ from: location }} replace />;
    }
    return children;
  }

  if (!admin) {
    return <Navigate to="/admin/login" state={{ from: location }} replace />;
  }

  if (roles && roles.length && !roles.includes(admin.role)) {
    // Signed in but with the wrong role — send them to their own panel.
    const target = admin.role === "super_admin" ? "/admin" : "/school";
    return <Navigate to={target} replace />;
  }

  return children;
}
